module.exports = __webpack_public_path__ + "img/Group 18.c3f945d4.png";